import(/* webpackMode: "eager", webpackExports: ["IndustrySolutionsPageContent"] */ "/app/components/frontend/industry-solutions/industry-solutions-page-content.tsx");
